import React from 'react';
import { gql } from 'urql';
import { SchoolRankCardFragment } from '../../../../generated/spin-graphql';
import { RankHead } from './RankHeader';
import { SchoolLineItem } from './SchoolLineItem';

type Props = {
    rankings: SchoolRankCardFragment[];
    title: string;
};

gql`
    fragment SchoolRankCard on espin_org_school {
        display_name
        city
        rank
        records {
            wins
            losses
            game {
                game_definition
                name
            }
        }
    }
`;

export const SchoolRankCard: React.FC<Props> = ({ rankings, title }) => {
    return (
        <div className={`rankings-card`}>
            <h2 className="rankings-title">{title}</h2>
            <div className="rankings-container">
                <div className="rankings">
                    <RankHead isPlayer={false} />
                    {rankings?.map((data, id) => (
                        <SchoolLineItem lineItem={data} key={id} />
                    ))}
                    {!rankings && (
                        <div className="no-rankings">
                            <p>Rankings coming soon!</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
